import { Modal } from "reactstrap"
import '../styles/post-image-modal.scss'

function PostImageModal({ isOpen, imageUrl, onToggle }) {
  return (
    <Modal id="post-image-modal" isOpen={isOpen} toggle={onToggle}>
      <img src={imageUrl} alt="post image"/>
    </Modal>
  )
}

export default PostImageModal
